import { useNavigate } from "react-router-dom";
import {
  getUserData,
  setSelectedSearchOrderType,
} from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "../../SchedularModal";
import { useEffect, useRef, useState } from "react";
import { formatDate, localeDateEndDate, localeDateStartDate, maskMobileNumber } from "../../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import StoreMenu from "../../StoreMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonLink from "../../../ButtonLink";
import { getAllCustomerPackageOffer } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import useSubscriptionPackageLogStore from "../../StoreContext/useSubscriptionPackageLogStore";

const { innerHeight: height } = window;

const SubscriptionPackageInfoStore = () => {
  const navigate = useNavigate();

  const { storeData, userProfileRole, brandProfileData } = getUserData();

  const storeId = storeData.id;
  const storeName = storeData.storeName;
  let brandId = brandProfileData.id;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;

  const {
    sortingData,
    setSortingData,
    validData,
    setValidData,
    schedularDate,
    setSchedularDate,
    customerALLOrdersData,
    setCustomerALLOrdersData,
    page,
    setPage,
    searchTerm,
    setSearchTerm,
    useEffectCall,
    setUseEffectCall,
  } = useSubscriptionPackageLogStore()

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  // const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  // const [page, setPage] = useState(0);
  // const [useEffectCall, setUseEffectCall] = useState(false);
  const [visible, setVisible] = useState(false);
  

  const initializeVariable = () => {
    setCustomerALLOrdersData([]);
  };
  
  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };
  
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const fetchPackageLogData = (data) => {
    setLoading(true);
    getAllCustomerPackageOffer(brandId, {
      ...data,
      limit: 15,
      offset: page * 15, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
        //   if (page === 0) {
        //     setCustomerALLOrdersData(Res); // Reset state with new data
        //   } else {
        //     setCustomerALLOrdersData((prevData) => [...prevData, ...Res]);
        //   }
        if (page === 0) {
            setCustomerALLOrdersData(Res); // Reset with fresh data
          } else {
            setCustomerALLOrdersData((prevData) => {
              const existingIds = new Set(prevData.map((item) => item.id));
              const newUniqueData = Res.filter((item) => !existingIds.has(item.id));
              return [...prevData, ...newUniqueData];
            });
          }
          setLoading(false);
          setLoadingSearch(false);
          setIsEndReached(Res.length < 15);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
      });
  };
  // for all status and one week data or by default data;
  const data = {
    stores: [storeId],
    brandId: brandId,
   statusIn: ["ACTIVE","RUNNING", "CONSUMED"],
  };
  const [requestData, setRequestData] = useState(data);

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
     requestData.startDate = schedularDate?.startDate
             ? localeDateStartDate(new Date(schedularDate.startDate))
             : validData ? null : localeDateStartDate(new Date(startDate));
           requestData.endDate = schedularDate?.endDate
             ? localeDateEndDate(new Date(schedularDate.endDate))
             : validData ? null : localeDateEndDate(new Date(endDate));
      setPage(0);
      fetchPackageLogData(requestData);
    }
  }, [schedularDate, validData]);

  useEffect(() => {
    fetchPackageLogData(data);
  }, []);

  useEffect(() => {
    if (page > 0) fetchPackageLogData(requestData);
  }, [page]);
 
    

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };
 
  const itemTemplate = (data) => {
    const formattedCreatedDate = formatDate(data.createdDate);
    const index = customerALLOrdersData.findIndex(
      item => item === data
    );
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            header={`${index + 1}`}
          >
          </AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
        <AccordionTab
          key={data.id} // Use a more unique key like data.id
          header={`${
            data?.brandPackageOffer?.name.replace(/_/g, " ") || "N/A"}`}
        >
          <div
            className="cursor-pointer"
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.brandPackageOffer?.name.replace(/_/g, " ") || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  App Service :
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.brandPackageOffer?.name.replace(/_/g, " ")}
                </p>
              </div>
            </div>

            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.brandPackageOffer?.name.replace(/_/g, " ") || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Mobile No.:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.brandPackageOffer?.name.replace(/_/g, " ") || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Notification:</p>
                <p className="text-lg font-bold capitalize">
                  {data?.brandPackageOffer?.name.replace(/_/g, " ") || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };


  const CustomerMobileBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
        
      > 
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                     rowData.totalDiscount > 0 &&
                      navigate("/All-Customer-Package-Offer-Log", {
                        state: {
                          brandId: brandId,
                          storeId: storeId,
                          storeCustomerId: rowData.storeCustomerId,
                          item: rowData,
                          customerData: rowData.customerName,
                        },
                      })
                    }
                    style={{ marginLeft: 10 }}
                  >
                    {rowData.totalDiscount > 0 ? 
            <span style={{ color: "blue", textDecoration: "underline" }}>{maskMobileNumber(rowData.customerMobile)}</span>       
                              : 
                              
            <span>{maskMobileNumber(rowData.customerMobile)}</span>
                              }
                  </div>
                
                
      </div>
    );
  };

  const rowClass = (rowData) => {
    return {
        'bg-carry-forward': rowData.carryForward
    };
};


  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={15}
        rowsPerPageOptions={[15, 20, 30, 50]}
        tableStyle={{ minWidth: "120rem" }}
        rowClassName={rowClass}
        scrollable
        scrollHeight={height - 160}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="date"
          header="Subscription Date"
          style={{ width: "130px" }}
          body={(rowData) => formatDate(rowData?.createdDate)}
        /><Column
          field="date"
          header="Valid From"
          style={{ width: "130px" }}
          body={(rowData) => formatDate(rowData?.validFrom)}
        /><Column
          field="date"
          header="Valid To"
          style={{ width: "130px" }}
          body={(rowData) => formatDate(rowData?.validTo)}
        />
        <Column
          field="carryForward"
          header="status"
          body={(rowData) => rowData?.status}
        ></Column>
        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "200px" }}
          body={(rowData) => rowData?.customerName}
        />
        <Column
          field="customerMobile"
          header="Customer Mobile"
          style={{ width: "120px" }}
          body={CustomerMobileBodyTemplate}
          // body={(rowData) => "Customer Mobile"}
        ></Column>
        <Column
          field="PackageAmount"
          header="Package Name"
          body={(rowData) => rowData?.brandPackageOffer?.name.replace(/_/g, " ")}
        ></Column>
        <Column
          field="PackageAmount"
          header="Discount"
          body={(rowData) => rowData?.brandPackageOffer?.value + ' %'}
        ></Column>
        
        <Column
          field="totalPrice"
          header="Service Value"
          body={(rowData) => rowData?.brandPackageOffer?.serviceValue}
        ></Column>
        <Column
          field="packageCount"
          header="Package Value"
          body={(rowData) => rowData?.brandPackageOffer?.packageValue}
        ></Column>
        <Column
          field="quantityUsed"
          header="Consumed Discount"
          body={(rowData) => Number(rowData?.totalDiscount)?.toFixed(enabledAmountRoundOff)}
        ></Column>
        <Column
          field="itemGarmentCount"
          header="Left Discount"
          body={(rowData) => Number(rowData?.leftDiscount)?.toFixed(enabledAmountRoundOff)}
        ></Column>
        <Column
          field="itemGarmentCount"
          header="Left Service Value (appx.)"
          body={(rowData) => Number(rowData?.leftServiceValue)?.toFixed(enabledAmountRoundOff)}
        ></Column>
        <Column
          field="carryForwardInvoiceNo"
          header="Subscription Count"
          body={(rowData) => rowData?.subsCount}
        ></Column>
      </DataTable>
    );
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };

  const filteredOrderInfoData = filterData(customerALLOrdersData, searchTerm);

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Map only the required fields for export
      const exportData = filteredOrderInfoData.map((item) => ({
        "Subscription Date": formatDate(item?.createdDate),
        "Valid From": formatDate(item?.validFrom),
        "Valid To": formatDate(item?.validTo),
        "Status": item?.status,
        "Customer Name": item?.customerName,
        "Customer Mobile": maskMobileNumber(item?.customerMobile),
        "Package Name": item?.brandPackageOffer.name.replace(/_/g, " "),
        "Discount": item?.brandPackageOffer.value + " %",
        "Service Value": item?.brandPackageOffer.serviceValue,
        "Package Value": item?.brandPackageOffer.packageValue,
        "Consumed Discount": Number(item?.totalDiscount)?.toFixed(enabledAmountRoundOff),
        "Left Discount": Number(item?.leftDiscount)?.toFixed(enabledAmountRoundOff),
        "Left Service Value (appx.)": Number(item?.leftServiceValue)?.toFixed(enabledAmountRoundOff),
        "Subscription Count": item?.subsCount,
      }));
  
      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
  
      saveAsExcelFile(excelBuffer, "My_" + storeName + "_Store_Subscription_Log");
    });
  };

  
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Subscription-Package")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Subscription Log
              </p>
            </div>
          </div>
           <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={exportExcel}
                  src={"images/file.png"}
                  style={{
                    width: 30,
                  }}
                />
              </div>
            </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : customerALLOrdersData?.length > 0 ? (
          <div>
          <div>
          
            <div
              className="scroll-bar mb-2"
            >
            <div className="mx-4 report-table">
              <div className="tab-view-table">{RenderTabView()}</div>
            </div>
            </div>
          
          </div>
          <div style={{display:"none"}}>
              <DataScroller
                value={customerALLOrdersData}
                itemTemplate={itemTemplate}
                rows={customerALLOrdersData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height - 200}
                loader
                // footer={footer}
              />
            </div>
            </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Notification Found</p>
          </div>
        )}

        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 20, left: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>

        <SchedularModal
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
        />
        <StoreMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default SubscriptionPackageInfoStore;
